<div
  class="composable-card"
  [ngClass]="[
    config()?.backgroundColorClass ?? '',
    config()?.borderClass ?? '',
    config()?.borderRoundingClass ?? '',
  ]"
  [class.rounded]="config()?.rounded"
  [class.h-100]="config()?.stretchVertical"
>
  <ng-content></ng-content>
</div>
